module.exports = __webpack_public_path__ + "img/prolunga.b4b50e07.jpg";